import useTranslationHook from "hooks/useTranslationHook";
import styles from "../../PropertyDetailsModal.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import CloseIcon from "@Icons/CloseIcon";
import { useHistory } from "hooks/useHistory";

const DetailsHeader = ({
  header,
  isDesktop = true,
  hidePropertyModal,
  isListingPage = false,
}: {
  header: string;
  isDesktop?: boolean;
  hidePropertyModal?: (e?: any) => void;
  isListingPage?: boolean;
}) => {
  const { t } = useTranslationHook();
  const history = useHistory();
  const onCLickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isListingPage) history.goBack();
    if (hidePropertyModal) hidePropertyModal(e as any);
  };
  return (
    <div data-testid="property-section-modal-header" className={styles.detailsHeader}>
      {typeof header !== "string" ? header : t(header)}
      {!isDesktop && (
        <button className={styles.closeButton} type="button" onClick={onCLickHandler}>
          <CloseIcon stroke="#374151" size={16} strokeWidth="2" />
          <span style={{ display: "none" }}>close</span>
        </button>
      )}
    </div>
  );
};

export default wrapperHOC(DetailsHeader, {
  componentName: "DetailsHeader-PropertyDetailsModal-PropertyPage",
  showForChina: true,
});
